import { nodeListToArray } from '../helpers/nodeListToArray';
import { SvgSprite } from '../classes/helper/svg-loader';
import { Modal } from '../classes/modal';
import { RevealPanel } from '../classes/revealPanel';
import { Accordion } from '../classes/accordion';
import { ResponsiveTable } from '../classes/responsiveTable';
import { SchoolsList } from '../classes/schoolsList';
import { DesktopNav } from '../instances/desktopNavigation';
import { MobileNav } from '../instances/mobileNavigation';
import { LinkBarSubNavigation, FixedLinkBarHeaders } from '../instances/LinkBarSubNavigation';
import { FixedHeaders } from '../instances/navHeights';
import { globalAlert } from '../instances/alerts';
import { ITabOptions, Tabs } from '../classes/tabs';
import { QueryStringFormBlock } from '../classes/querystring-form-block';
import { infoButton } from '../instances/info-button';
import { GlideSlider } from '../classes/glide-slider';
import { GlideCarousel } from '../classes/carousel';
import { OppotrunityList } from '../pages/opportunities/opportunities-list';
import { VideoGallery } from '../classes/video-gallery';
import { OpportunityIndexSearch } from "../classes/opportunitiesIndexBlock";
import { PrintManager } from "../classes/opportunity-print-manager";

import '../helpers/clearForm';
import '../helpers/richTextField';
import '../helpers/formDependencies';
import '../helpers/newsCategorySearch';
import '../helpers/policyPromoBlock';

let debounce = require('lodash.debounce');
let throttle = require('lodash.throttle');
import { initGlobalSearchAutocomplete } from '../classes/search-autocomplete';
import { initPolicySearchAutocomplete } from '../classes/policy-search-autocomplete';
import internal = require('assert');
import tippy from 'tippy.js';
import lightGallery from 'lightgallery';
// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import { infoBubble } from '../helpers/infoBubble';
import { Chart } from "chart.js";
import { htmlLegendPlugin } from '../pages/profiles/configs';

Chart.register(htmlLegendPlugin);


(() => {
    if (DesktopNav && MobileNav) {
        DesktopNav.init();
        MobileNav.init();
    }
    const lbNavContainers = nodeListToArray(document.querySelectorAll('[data-linkbar-nav]'));
    lbNavContainers.forEach((lbNavContainer) => {
        new LinkBarSubNavigation(lbNavContainer).init();
    });

    //Site Alert Script
    globalAlert();
    infoButton();
    initGlobalSearchAutocomplete();
    initPolicySearchAutocomplete();
    new QueryStringFormBlock();
    new SvgSprite('/Static/img/sprite.svg');

    // Modals Init
    const modals = nodeListToArray(document.querySelectorAll('[data-modal]'));
    modals.forEach(modal => {
        new Modal(modal);
    });

    // Glide slider
    const glidesSliders = nodeListToArray(document.querySelectorAll('.glide-slider'));
    glidesSliders.forEach((slider, index) => {
        const _class = `glide-slider-${index}`;
        slider.classList.add(_class);
        const options = {
            class: _class,
            duration: slider.getAttribute('data-duration') > 0 && slider.getAttribute('data-duration'),
            transition: slider.getAttribute('data-transition') > 0 && slider.getAttribute('data-transition'),
            type: slider.getAttribute('data-transition-type')
        }
        new GlideSlider(options);
    })

    // Glide Carousel
    const glidesCarousels = nodeListToArray(document.querySelectorAll('.glide-carousel'));
    console.log()
    glidesCarousels.forEach((slider, index) => {
        const _class = `glide-carousel-${index}`;
        slider.classList.add(_class);
        const options = {
            class: _class,
            duration: slider.getAttribute('data-duration') > 0 && slider.getAttribute('data-duration'),
            transition: slider.getAttribute('data-transition') && Number(slider.getAttribute('data-transition')) > 0 ? Number(slider.getAttribute('data-transition')) : 300,
            type: slider.getAttribute('data-transition-type'),
            perView: slider.hasAttribute('data-count') ? Number(slider.getAttribute('data-count')) : 1,
            gap: slider.hasAttribute('data-gap') && Number(slider.hasAttribute('data-gap')) > 0 ? Number(slider.hasAttribute('data-gap')) : 15
        }
        new GlideCarousel(options);
    })

    // Set up any reveal panels inside WYSIWYGs
    const readmoreTriggers = nodeListToArray(document.querySelectorAll('[data-readmore-trigger]'));
    readmoreTriggers.forEach((trigger, index) => {
        const panelId = `readmorePanel-${index}`;
        if (trigger.querySelector('button')) {
            trigger.querySelector('button').setAttribute('aria-controls', panelId);
            const nextPanel = trigger.nextElementSibling;
            if (nextPanel.hasAttribute('data-readmore-region')) {
                nextPanel.id = panelId;
                new RevealPanel(panelId);
            }
        }
    });

    // Init of any simple reveal panels
    const revealPanelElements = nodeListToArray(document.querySelectorAll('[data-panel]'));
    let revealPanels = [];
    revealPanelElements.forEach(panelEl => {
        revealPanels.push(new RevealPanel(panelEl.id));
    });

    // Accordion Init
    const accordions = nodeListToArray(document.querySelectorAll('[data-accordion-list]'));
    accordions.forEach(accordion => {
        const oneOpen = accordion.getAttribute('data-one-open-at-a-time');
        new Accordion({
            container: accordion,
            oneOpenAtATime: oneOpen === 'True'
        });
    });

    // Responsive Tables in WYSIWYGs
    const tables = nodeListToArray(document.querySelectorAll('.rich-text table')) as Array<HTMLTableElement>;
    tables.forEach(table => {
        new ResponsiveTable(table);
    });

    const tabs = nodeListToArray(document.querySelectorAll('[data-tabs-container]')) as HTMLElement[];
    tabs.forEach(tabs => {
        let options: ITabOptions = {
            container: tabs
        }
        new Tabs(options);
    });

    // Schools Lists (Participating Schools Block)
    const lists = [].slice.call(document.querySelectorAll('[data-schools-list]')) as HTMLUListElement[];
    lists.forEach(list => {
        new SchoolsList(list);
    });

    // Linkbar Sticky Nav toggle
    const linkBarStickyNavs = document.querySelectorAll('[data-linkbar-nav]') as NodeListOf<HTMLElement>;

    const infoBubbles = nodeListToArray(document.querySelectorAll('.cps-info-bubble')) as Array<HTMLElement>;
    for (let bubble of infoBubbles) {
        tippy(bubble, {
            content: bubble.getAttribute('title'),
            trigger: 'click',
            // 4821: pin the site theme (_global/basic-patterns/_tooltip.scss) so the
            // tooltip look no longer depends on stylesheet load order.
            theme: 'cps'
        });
    }

    if (linkBarStickyNavs) {
        Array.from(linkBarStickyNavs).forEach((linkBarStickyNav) => {

            // Get the offset position of the linkbar nav
            const stickyPosition = linkBarStickyNav.offsetTop;

            function linkBarToggleSticky() {
                if (window.pageYOffset >= stickyPosition) {
                    linkBarStickyNav.setAttribute("data-sticky", "true");
                } else {
                    linkBarStickyNav.setAttribute("data-sticky", "false");
                }
            }

            window.addEventListener('scroll', throttle(() => {
                linkBarToggleSticky();
            }, 10));

        });
    }
    // fix for linkbar nav height
    if (FixedLinkBarHeaders) {
        FixedLinkBarHeaders.setHeightProperties();
    }

    // Back to Top
    const topLink = document.querySelector('[data-top-link]') as HTMLAnchorElement;
    const topAnchor = document.querySelector('#top') as HTMLAnchorElement;
    let screenHeight = window.innerHeight;
    let totalHeight = document.documentElement.scrollHeight;
    if (topLink) {
        topLink.addEventListener('click', (e) => {
            e.preventDefault();
            topAnchor.focus();
            window.scroll(0, 0);
        });
    }
    const prevWidth = window.innerWidth;
    window.addEventListener('resize', debounce(() => {
        const width = window.innerWidth;
        if (width !== prevWidth) {
            revealPanels.forEach(panel => {
                panel.testBreakpoint();
            });
        }
        screenHeight = window.innerHeight;
        totalHeight = document.documentElement.scrollHeight;
        if (FixedHeaders) {
            FixedHeaders.setHeightProperties();
        }
        if (MobileNav) {
            MobileNav.testBreakpoint();
        }
    }, 50));

    if (topLink) {
        checkScrollTopLink();
        window.addEventListener('scroll', throttle(() => {
            checkScrollTopLink();
        }, 10));
    }

    function checkScrollTopLink() {
        if (window.scrollY > screenHeight && screenHeight * 3 < totalHeight) {
            topLink.setAttribute('aria-hidden', 'false');
            topLink.tabIndex = 0;
        } else {
            topLink.setAttribute('aria-hidden', 'true');
            topLink.tabIndex = -1;
        }
    }


    /* Chose tab if isset url hash */
    if (window.location.hash) {
        const hashId = window.location.hash.split('#').pop();
        localStorage.setItem('schoolhash', hashId);
    }
    window.onunload = function () {
        localStorage.removeItem('schoolhash');
    }

    /* Pass this code in EPI -> Edit -> School Profile Page -> Content -> Head Embed */

    /*
        <script>
         setTimeout(() => {
            const hashId = localStorage.getItem('schoolhash');
            const el = document.getElementById(hashId) || document.querySelector(`[aria-title=${hashId}]`)
            if(el) {
               setTimeout(() => {el.click()}, 1000)
            }
        }, 300);
        </script>
    */


    window.addEventListener('DOMContentLoaded', function () {
        var rotationInterval = document.getElementById("sliderRotationInternal") != null ? Number((<HTMLInputElement>document.getElementById("sliderRotationInternal")).value) : 0;
        var animationInterval = document.getElementById("sliderAnimationInternal") != null ? Number((<HTMLInputElement>document.getElementById("sliderAnimationInternal")).value) : 0;
        var desktopImages = document.getElementById("sliderDesktopImages") != null ? (<HTMLInputElement>document.getElementById("sliderDesktopImages")).value.split(',') : '';


        if (desktopImages.length > 1) {
            var j = 0;
            setInterval(() => {
                document.getElementById("desktopImage").classList.remove("visible");
                document.getElementById("desktopImage").classList.add("hidden");
                setTimeout(() => {
                    var currentImage = document.getElementById("desktopImage").style.backgroundImage;
                    document.getElementById("desktopImage").style.backgroundImage = "url(" + desktopImages[j] + ")";
                    if (currentImage !== "url(" + desktopImages[j] + ")") {
                        document.getElementById("desktopImage").classList.remove("hidden");
                        document.getElementById("desktopImage").classList.add("visible");
                    }
                }, animationInterval);

                j = j + 1;
                if (j == desktopImages.length) {
                    j = 0;
                }
            }, rotationInterval);
        }

        if (document.getElementById("mobileImage") != null) {
            var mobileImages = (<HTMLInputElement>document.getElementById("sliderMobileImages")).value.split(',');
            if (mobileImages.length > 1) {
                var i = 0;
                setInterval(() => {
                    document.getElementById("mobileImage").classList.remove("visible");
                    document.getElementById("mobileImage").classList.add("hidden");

                    setTimeout(() => {
                        document.getElementById("mobileImage").style.backgroundImage = "url(" + mobileImages[i] + ")";
                    }, animationInterval);

                    document.getElementById("desktopImage").classList.remove("hidden");
                    document.getElementById("desktopImage").classList.add("visible");

                    i = i + 1;
                    if (i == mobileImages.length) {
                        i = 0;
                    }

                }, rotationInterval);
            }
        }
    });

    /*  Fit Text   */

    const fitText = function (el, isMobile?) {
        interface BlockSizeI {
            width: number;
            height: number;
        }

        const logoColors = {
            'cyan': '#50C4D9',
            'dark-blue': '#061A53',
            'blue': '#1D48C0'
        }
        const displayTextWidth = function (text, font) {
            // @ts-ignore
            let canvas = displayTextWidth.canvas || (displayTextWidth.canvas = document.createElement("canvas"));
            let context = canvas.getContext("2d");
            context.font = font;
            let metrics = context.measureText(text);
            return Number(metrics.width.toFixed());
        }
        const fit = function (el) {
            const resizer = function () {
                const titleEl = document.getElementsByClassName(`has-microsite-title${isMobile ? '-mobile' : ''}`)[0];
                const titleElText = el.getAttribute('data-value').trim();
                const titleDividerText = el.getAttribute('data-divider-color').trim();
                const titleElSize: BlockSizeI = {
                    width: isMobile ? (titleEl.clientWidth * .4) - 5 : ((titleEl.clientWidth - 30) * .4) - 15,
                    height: titleEl.clientHeight
                }
                const titleElFontSize = 16;
                const titleElTextFontFamily = window.getComputedStyle(el, null).getPropertyValue('font-family');

                const isFontGood = function (blockSize: BlockSizeI, fontSize: number, text: string) {
                    const font = `normal ${fontSize}px ${titleElTextFontFamily}`
                    const textLenght = displayTextWidth(text, font)
                    const textHeight = (fontSize + 3) * Math.ceil(textLenght / blockSize.width)

                    if (textHeight > blockSize.height) {
                        return false;
                    }

                    const wordArray = text.split(' ');
                    if (wordArray.some(i => displayTextWidth(i, font) > blockSize.width)) {
                        return false;
                    }
                    return true;
                }

                const returnFontSize = function (fontSize: number, text: string) {
                    return isFontGood(titleElSize, fontSize, text) || fontSize === 1 ? fontSize : returnFontSize(fontSize - .5, text)
                }

                el.style.fontSize = returnFontSize(titleElFontSize, titleElText) + 'px';
                el.innerHTML = `<span>${titleElText} </span>`;
                el.style.display = 'flex';
                el.style.borderColor = logoColors[titleDividerText]

            };
            resizer();
        };

        if (el.length)
            for (let i = 0; i < el.length; i++)
                fit(el[i]);
        else
            fit(el);

        return el;
    };


    if (document.getElementById('multisite-title')) {
        fitText(document.getElementById('multisite-title'));
        window.addEventListener("resize", (event) => fitText(document.getElementById('multisite-title')));
    }
    if (document.getElementById('multisite-title-mobile')) {
        fitText(document.getElementById('multisite-title-mobile'), true);
        window.addEventListener("resize", (event) => fitText(document.getElementById('multisite-title-mobile'), true));
    }

    /** Full Width Overflow Block */
    const fullWidthBlocks = document.getElementsByClassName('fullWidthOverflowBlock');
    if (document.getElementsByClassName('fullWidthOverflowBlock') && document.getElementsByClassName('fullWidthOverflowBlock').length > 0) {
        var hasVScroll = document.body.scrollHeight > document.body.clientHeight;
        if (!hasVScroll) {
            for (let i = 0; i < fullWidthBlocks.length; i++) {
                fullWidthBlocks[i]['style'].width = '100vw';
            }
        }
    }

    /** Video gallery block **/
    const videoGalleryBlocks = document.querySelectorAll('.video-gallery-section');

    videoGalleryBlocks.forEach(videoGalleryBlock => {
        new VideoGallery(videoGalleryBlock)
    });

    /* Opprtunity List Page */
    window.addEventListener("beforeunload", function (e) {
        const detailPage = document.getElementById('opportunityDetailPage')
        const oportunityListId = document.getElementById('opportunityListPage');
        detailPage
            ? localStorage.setItem('fromOpportunityDetailPage', 'true')
            : localStorage.removeItem('fromOpportunityDetailPage')
        if (oportunityListId) {
            localStorage.setItem('opportunityList-url', window.location.href);
        } else {
            localStorage.removeItem('opportunityList-url');
        }
    });
    const oportunityListId = document.getElementById('opportunityListPage');
    if (oportunityListId) {
        const contentIdEl = oportunityListId.querySelector('input[name=contentId]')
        if (contentIdEl) {
            const opportunityListInstance = new OppotrunityList(oportunityListId, contentIdEl.getAttribute('value'));
            opportunityListInstance.init();
        }
    }

    const opportunityBackLink = document.getElementById('backToOpportunities');
    if (opportunityBackLink) {
        const listUrl = localStorage.getItem('opportunityList-url');
        if (listUrl) {
            opportunityBackLink['href'] = listUrl;
        } else {
            const pathname = window.location.pathname.split('/').filter(i => i !== '');
            opportunityBackLink['href'] = `${window.location.origin}/${pathname.slice(0, pathname.length - 1).join('/')}`;
        }
    }

    /* Light Gallery */
    const arbGallery = document.getElementsByClassName('arb-lightgallery');
    if (arbGallery) {
        Array.from(arbGallery).forEach((item) => {
            lightGallery(item as HTMLElement, {
                licenseKey: 'your_license_key',
                plugins: [lgZoom],
                speed: 300,
                download: false,
                share: false,
                actualSize: false,
            });

            const itemsCount = Number(item.getAttribute('data-itemsCount'));
            const limitAttr = item.getAttribute('data-limit');
            const limit = limitAttr ? Number(limitAttr) : itemsCount;

            const images = item.querySelectorAll('.arb-galery-item');

            images.forEach((image, index) => {
                if (index >= limit) {
                    (image as HTMLElement).style.display = 'none';
                }
            });

            if (itemsCount > limit && images.length > limit) {
                const summaryImage = images[limit - 1] as HTMLElement;
                summaryImage.classList.add('hover-bg');
                summaryImage.innerHTML += `<span class="imageCount">${itemsCount - limit}+</span>`;
            }
        });
    }

    /* Sidebar Dropdown  */
    document.querySelectorAll('.has-dropdown .main-item').forEach((item: HTMLElement) => {
        const arrow = item.querySelector('.svg-icon-md') as HTMLElement | null;
        const changeMobileNavHeight = (item: HTMLElement, ariaExpanded: boolean) => {
            const parentPanelEl: HTMLElement = item.closest('[data-panel]');
            const itemHeight = item.nextElementSibling as HTMLElement | null;
            if (itemHeight) {
                let height = ariaExpanded
                    ? parentPanelEl.scrollHeight + itemHeight.scrollHeight
                    : parentPanelEl.scrollHeight - itemHeight.scrollHeight;
                parentPanelEl.style.height = `${height - 20}px`;
            }
        }
        // Toggle function to handle expansion
        const toggleDropdown = (e): void => {
            // probably a better way to scope this to be more flexible, for now just limiting to profile pages
            const inProfile = item.closest('.school-profile');
            const expanded: boolean = item.getAttribute('aria-expanded') === 'true';
            const links = item.querySelectorAll('a');
            // there's a `use` element inside of the svg, check if we hit that too
            const arrowClicked = e.target.tagName == 'svg' || e.target.parentElement.tagName == 'svg';
            if (inProfile != null && links.length > 0) {
                const linkLocation = links[0].href ?? '';
                const samePage = location.href == linkLocation;
                if (!samePage && !arrowClicked) {
                    return;
                }
            }
            item.setAttribute('aria-expanded', String(!expanded));

            const subList = item.nextElementSibling as HTMLElement | null;
            if (subList) {
                subList.style.maxHeight = expanded ? '0' : `${subList.scrollHeight + 20}px`;
                if (window.outerWidth < 992) {
                    changeMobileNavHeight(item, item.getAttribute('aria-expanded') === 'true');
                }
            }
        };

        // Attach click event to the arrow
        if (item) {
            //item.addEventListener('click', toggleDropdown);
        }
        if (item.getAttribute('aria-expanded') === 'true') {
            const subList = item.nextElementSibling as HTMLElement | null;
            if (subList) {
                subList.style.maxHeight = `${subList.scrollHeight + 20}px`;
            }
        }
    });
    /* --------- */
    document.querySelectorAll<HTMLElement>('[data-toggle="school-profile-tooltip"]').forEach((el) => {
        infoBubble(el);
    });

    document.addEventListener('DOMContentLoaded', () => {
        // Get dropdown element and all tables
        const programNameDropdown = document.getElementById('program_name_dropdown') as HTMLSelectElement;
        const tables = document.querySelectorAll('.bas-table') as NodeListOf<HTMLElement>;

        if (!programNameDropdown) {
            return;
        }

        // Function to handle dropdown change and show the appropriate table
        const handleDropdownChange = (): void => {
            const selectedValue = programNameDropdown.value;

            // Hide all tables
            tables.forEach((table) => {
                table.style.display = 'none';
            });

            // Show the selected table
            const selectedTable = document.getElementById(selectedValue);
            if (selectedTable) {
                selectedTable.style.display = 'block';
            }
        };

        // Set default selection or first
        if (programNameDropdown.options.length > 0) {
            const defaultValue = programNameDropdown.value || programNameDropdown.options[0].value;
            programNameDropdown.value = defaultValue; // Ensure the dropdown has a selected value
            handleDropdownChange(); // Show the default/first table
        }

        // Add event listener for dropdown change
        programNameDropdown.addEventListener('change', handleDropdownChange);
    });

    document.addEventListener("DOMContentLoaded", () => {

        const el = document.getElementById('opportunity-index-search-block');
        const printBtn = document.querySelector('.printPDFbtn');
        if (el) {
            const widget = new OpportunityIndexSearch("#opportunity-index-search-block");
            widget.init().catch(console.error);
        }
        if (printBtn) {
            new PrintManager();
        }
    });
    document.addEventListener('DOMContentLoaded', () => {
        const containers = document.querySelectorAll<HTMLElement>('.promo-listing-image');

        containers.forEach(container => {
            const img = container.querySelector<HTMLImageElement>('img');

            if (!img) return;

            const markAsLoaded = () => {
                container.classList.add('image-loaded');
            };

            if (img.complete && img.naturalHeight !== 0) {
                markAsLoaded();
            } else {
                img.addEventListener('load', markAsLoaded);
                img.addEventListener('error', () => {
                    console.warn('Image failed to load:', img.src);
                });
            }
        });
    });

})();

(function () {


})();